import { render, staticRenderFns } from "./GItemTopTable.vue?vue&type=template&id=8af6f300&scoped=true&"
import script from "./GItemTopTable.vue?vue&type=script&lang=ts&"
export * from "./GItemTopTable.vue?vue&type=script&lang=ts&"
import style0 from "./GItemTopTable.vue?vue&type=style&index=0&id=8af6f300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af6f300",
  null
  
)

export default component.exports